module.exports = __webpack_public_path__ + "static/media/recovery-book8.864a1e28.png";